import { debounce } from 'throttle-debounce';
import { closest } from 'vue-xpc/src/utils/util.js';

const STICKY_CONTAINER = 'rt-xpc-sticky-container';
const STICKY_ITEM = 'rt-xpc-sticky';
const STICKY_BOTTOM_ITEM = 'rt-xpc-sticky-bottom';
const STICKY_GROUP = 'rt-xpc-sticky-group';
const STICKY_CLASS = 'rt-xpc-sticky';
const STICKY_AFTER_CLASS = 'sticky-after-class';
const IS_STICKY = 'is-sticky';

export default {
  props: {},
  provide () {
    return {
      rtXpcStickyContainer: this,
      rtXpcStickyItems: this.rtXpcStickyItems
    };
  },
  data () {
    return {
      rtXpcStickyContainer: this,
      container: null,
      rtXpcStickyItems: {}
    };
  },
  watch: {
    container (val) {
      if (val) {
        if (!val.getAttribute(STICKY_CONTAINER)) {
          val.setAttribute(STICKY_CONTAINER, rt.newUUID());
        }
        this.init();
        this.stickyContainerScrollHandler();
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getContainer();
      if (!this.container) {
        return;
      }
      const parentContainer = closest(this.container, `[${STICKY_CONTAINER}]`);
      if (parentContainer) {
        return;
      }
      if (window.__RT_QIANKUN_WINDOW__ === window) {
        window.rtXpcStickyContainer = this.rtXpcStickyContainer;
      }
      this.debouncedUpdateLayout = debounce(100, () => this.containerListener());
      this.init();
      this.stickyContainerScrollHandler();
      if (typeof ResizeObserver === 'function') {
        const resizeOb = new ResizeObserver(() => {
          this.debouncedUpdateLayout();
        });

        resizeOb.observe(this.container);

        this.$once('hook:beforeDestroy', () => {
          resizeOb.unobserve(this.container);
        });
      }
    });
  },

  beforeDestroy () {
    this.destroyHandler();
  },
  methods: {
    isSticky (el) {
      return !!el && el.classList.contains(IS_STICKY)
    },
    containerListener () {
      if (this.container) {
        this.init();
        this.stickyContainerScrollHandler();
      }
    },
    init () {
      this.destroyHandler();
      if (this.container) {
        this.container.addEventListener('DOMNodeInserted', this.debouncedUpdateLayout);
        this.container.addEventListener('DOMNodeRemoved', this.debouncedUpdateLayout);

        this.topItems = this.container.querySelectorAll(`[${STICKY_ITEM}]`);
        this.bottomItems = this.container.querySelectorAll(
          `[${STICKY_BOTTOM_ITEM}]`
        );

        let topItems = []
        this.topItems.forEach(item => {
          if (item[STICKY_ITEM] !== undefined) {
            let obj = {
              el: item
            }
            // 当吸顶元素已经被初始化后，不再对stickScrollTop赋值
            const stickyItem = this.rtXpcStickyItems.top.find(n => n.el === item)
            if (this.isSticky(item) && stickyItem) {
              obj.stickyScrollTop = stickyItem.stickyScrollTop;
            } else {
              obj.stickyScrollTop = item.getBoundingClientRect().top - this.container.getBoundingClientRect().top + this.container.scrollTop - item[STICKY_ITEM];
            }
            topItems.push(obj)
          }
        });
        this.rtXpcStickyItems.top = topItems

        this.topItemsResizeOb = this.topItems && Array.from(this.topItems).map((item) => {
          if (typeof ResizeObserver === 'function') {
            const resizeOb = new ResizeObserver(() => {
              if (item) {
                this.getStickiesPosition(this.topItems);
              }
            });
            resizeOb.observe(item);
            return resizeOb;
          }
        });
        this.bottomItemsResizeOb = this.bottomItems && Array.from(this.bottomItems).map((item) => {
          if (typeof ResizeObserver === 'function') {
            const resizeOb = new ResizeObserver(() => {
              if (item) {
                this.getStickiesPosition(Array.from(this.bottomItems).reverse(),
                  'bottom');
              }
            });
            resizeOb.observe(item);
            return resizeOb;
          }
        });

        this.getStickiesPosition(this.topItems);
        this.getStickiesPosition(
          Array.from(this.bottomItems).reverse(),
          'bottom'
        );
        this.container.addEventListener('scroll', this.stickyContainerScrollHandler);
      }
    },
    destroyHandler () {
      if (this.container) {
        this.container.removeEventListener('scroll', this.stickyContainerScrollHandler);
        this.container.removeEventListener('DOMNodeInserted', this.debouncedUpdateLayout);
        this.container.removeEventListener('DOMNodeRemoved', this.debouncedUpdateLayout);
      }
      if (this.topItems && this.topItemsResizeOb) {
        this.topItemsResizeOb.forEach((ob, index) => ob.unobserve(this.topItems[index]));
      }
      if (this.bottomItems && this.bottomItemsResizeOb) {
        this.bottomItemsResizeOb.forEach((ob, index) => ob.unobserve(this.bottomItems[index]));
      }
    },
    getContainer (vm = this) {
      let container;
      if (vm.$el && vm.$el.hasAttribute(STICKY_CONTAINER)) {
        container = vm.$el;
      } else {
        container = vm.$el && vm.$el.querySelector(`[${STICKY_CONTAINER}]`);
      }
      // 如果没有找到，则说明容器是在弹窗一类组件内，需要通过Vue子组件查找
      if (!container) {
        container = this.getChildrenContainer(vm);
      }
      this.container = container;
      return container;
    },
    getChildrenContainer (vm) {
      if (vm.$el && vm.$el.hasAttribute && vm.$el.hasAttribute(STICKY_CONTAINER)) {
        this.innerContainer = vm.$el;
      } else {
        this.innerContainer = vm.$el && vm.$el.querySelector && vm.$el.querySelector(`[${STICKY_CONTAINER}]`);
      }

      if (!this.innerContainer) {
        vm.$children && vm.$children.forEach((vn) => {
          if (!this.innerContainer) {
            this.innerContainer = this.getChildrenContainer(vn);
          }
        });
      }
      return this.innerContainer;
    },
    getStickiesPosition (nodes, direction = 'top') {
      let top = 0;
      const attr = direction === 'top' ? STICKY_ITEM : STICKY_BOTTOM_ITEM;
      const defaultArr = [];
      const map = new Map();
      Array.from(nodes).forEach(item => {
        const { height } = item.getBoundingClientRect();
        item.classList.add(STICKY_CLASS);
        const key = item.getAttribute(STICKY_GROUP);
        if (key) {
          if (map.has(key)) {
            defaultArr.push(map.get(key));
            item.style[direction] = map.get(key) + 'px';
            item[attr] = map.get(key);
          } else {
            map.set(key, top);
            item.style[direction] = top + 'px';
            item[attr] = top;
            top += height;
          }
        } else {
          defaultArr.push(top);
          if (key) {
            map.set(key, top);
          }
          item.style[direction] = top + 'px';
          item[attr] = top;
          top += height;
        }
      });
    },
    stickyContainerScrollHandler (e) {
      if (this.container) {
        const containerRect = this.container.getBoundingClientRect();

        this.topItems && this.topItems.forEach(item => {
          const itemRect = item.getBoundingClientRect();
          const className = item.getAttribute(STICKY_AFTER_CLASS);
          if (item[STICKY_ITEM] >= itemRect.top - containerRect.top) {
            item.classList.add(IS_STICKY);
            if (className) {
              item.classList.add(className);
            }
          } else {
            item.classList.remove(IS_STICKY);
            if (className) {
              item.classList.remove(className);
            }
          }
        });

        this.bottomItems && this.bottomItems.forEach(item => {
          const itemRect = item.getBoundingClientRect();
          const className = item.getAttribute(STICKY_AFTER_CLASS);

          if (
            item[STICKY_BOTTOM_ITEM] <=
          itemRect.bottom - containerRect.bottom
          ) {
            item.classList.add(IS_STICKY);
            if (className) {
              item.classList.add(className);
            }
          } else {
            item.classList.remove(IS_STICKY);
            if (className) {
              item.classList.remove(className);
            }
          }
        });
      }
    },
    scrollStickyItem (el) {
      if (this.container) {
        const stickyItem = this.rtXpcStickyItems.top.find(item => { return el.contains(item.el) })
        if (stickyItem && this.isSticky(stickyItem.el)) {
          this.container.scrollTop = stickyItem.stickyScrollTop
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/mixins/sticky/stickyContainer.js